export default [
  {
    name: "environmentMapTexture",
    type: "cubeTexture",
    path: [
      "textures/environmentMap/px.jpg",
      "textures/environmentMap/nx.jpg",
      "textures/environmentMap/py.jpg",
      "textures/environmentMap/ny.jpg",
      "textures/environmentMap/pz.jpg",
      "textures/environmentMap/nz.jpg",
    ],
  },
  {
    name: "groundModel",
    type: "gltfModel",
    path: "models/ground.glb",
  },
  {
    name: "boatModel",
    type: "gltfModel",
    path: "models/boat.glb",
  },
];
